<div class="body">
  <mat-toolbar class="toolbar">
    <div class="menu d-print-none">
      <button mat-icon-button class="noOutline" (click)="toggleSidenav()">
        <mat-icon>menu</mat-icon>
      </button>
    </div>
    <div class="full-width">
      <div class="row full-width">
        <div class="col-sm-12 col-md-2 d-print-none d-flex">
          <span class="toolbar-title">{{ moduleTitle }}</span>
        </div>
        <div
          class="col-sm-12 col-md-3 d-flex align-items-start flex-column justify-content-center"
        >
          <h1 [ngClass]="" id="serialNumber"></h1>
          <span class="status"> </span>
        </div>
        <div class="col-12 col-md-2 type-header d-flex align-items-center">
          <mat-form-field
            appearance="outline"
            *ngIf="element"
            class="no-subscript"
          >
            <mat-label>Operator initiating form</mat-label>
            <input
              aria-label="operator"
              matInput
              type="text"
              name="operator_form"
              [(ngModel)]="element.createdByName"
              disabled
            />
          </mat-form-field>
        </div>
        <div class="col-12 col-md-2 type-header d-flex align-items-center">
          <mat-form-field
            appearance="outline"
            *ngIf="element"
            class="no-subscript"
          >
            <mat-label>Created Date</mat-label>
            <input
              matInput
              class="dateInput"
              name="dateNow"
              placeholder="Date"
              disabled
              datetime="MM-dd-yyyy"
              [value]="formatDate(element.createdOn)"
            />
          </mat-form-field>
        </div>
        <div
          class="col-12 col-md-2 d-flex flex-column justify-content-center align-items-end"
        >
          <!-- <div class="d-flex small" *ngIf="showAmendmentToggle">
            <mat-slide-toggle
              [(ngModel)]="element.status.isViewingAmendment"
              class="float-right d-print-none"
              name="amendment"
              (change)="changeToggle($event)"
              >Show Pending Amendment</mat-slide-toggle
            >
          </div>
          <div class="d-flex small d-print-none" *ngIf="element?.editingBy">
            Modifying by:&nbsp;<b class="yellow">{{
              element?.editingBy?.name
            }}</b>
          </div> -->
        </div>
      </div>
    </div>
  </mat-toolbar>
  <mat-sidenav-container
    class="sidenav-container mat-sidenav-collapse-transition"
    autosize
  >
    <mat-sidenav
      [ngClass]="{ 'mat-sidenav-collapsed': !isExpanded && !isShowing }"
      #sidenav
      opened="true"
      class="d-print-none"
      mode="side"
      (mouseenter)="mouseenter()"
      (mouseleave)="mouseleave()"
    >
      <mat-nav-list>
        <mat-list-item>
          <mat-icon
            matListItemIcon
            *ngIf="!isExpanded && !isShowing"
            class="blue"
            >search</mat-icon
          >
          <filter-box
            [data]="menuItemsFilterData"
            (changed)="applyFilter($event)"
            *ngIf="isExpanded || isShowing"
            (selected)="filterResutSelected($event)"
          ></filter-box>
        </mat-list-item>

        <!-- <mat-list-item style="height: unset">
          <div [ngClass]="{ invisible: !isExpanded && !isShowing }">
            <template-side></template-side>

          </div>
        </mat-list-item> -->
      </mat-nav-list>

      <mat-nav-list>
        <mat-list-item (click)="edit.create()" class="parent" *ngIf="isSA()">
          <span class="full-width" *ngIf="isExpanded || isShowing"
            >Create New</span
          >
          <mat-icon matListItemIcon class="yellow">add_box</mat-icon>
        </mat-list-item>
      </mat-nav-list>
    </mat-sidenav>

    <mat-sidenav-content>
      <div class="d-flex flex-column justify-content-between">
        <div
          class="sidenav-content"
          [ngClass]="{
            amendment: false
          }"
        >
          <menu-config-head [SA]="isSA()"></menu-config-head>
          <menu-config-edit
            #edit
            (loading)="setLoading($event, loadingOrigin.Main)"
            [disabled]="!isSA()"
          ></menu-config-edit>
        </div>

        <div
          class="buttons d-print-none"
          id="sidenav-content-buttons"
          *ngIf="showButtons"
        >
          <div class="row">
            <div class="col">
              <button mat-flat-button color="warn" (click)="edit?.cancel()">
                Cancel
              </button>
            </div>
            <div class="col d-flex justify-content-end">
              <button
                class="w-100"
                mat-flat-button
                color="primary"
                (click)="edit?.save()"
                [disabled]="!isFormDirty() || !edit.formGroup.valid"
              >
                Save
              </button>
            </div>
          </div>
        </div>
      </div>
    </mat-sidenav-content>
  </mat-sidenav-container>

  <!-- "loading">
    <!-- Copyright 2017 Google Inc. All Rights Reserved.
      Use of this source code is governed by an MIT-style license that
      can be found in the LICENSE file at http://angular.io/license -->
  <!-- </overlay-loading> -->
</div>
